import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Echo from 'laravel-echo';
import Pusher from 'pusher-js'; // eslint-disable-line no-unused-vars
import { copyText } from 'helpers/helpers';
import CustomTooltip from 'pages/parts/CustomTooltip';

function Index() {
	const { t } = useTranslation()

	const socketRef = useRef(null)
	const usersRef = useRef([])

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({
		'users': [],
		'total': 0,
	})

	function connectSocket() {
		var wsHost;
		var authEndpoint;
		var isProd;

		if (process.env.NODE_ENV === 'production') {
			wsHost = process.env.REACT_APP_PROD_WSHOST
			authEndpoint = process.env.REACT_APP_PROD_BROADCAST_AUTH
			isProd = true
		} else {
			wsHost = process.env.REACT_APP_DEV_WSHOST
			authEndpoint = process.env.REACT_APP_DEV_BROADCAST_AUTH
			isProd = false
		}

		try {
			socketRef.current = new Echo({
				broadcaster: 'pusher',
				key: "mison_key",
				wsHost: wsHost,
				wsPort: 6001,
				wssPort: 6001,
				enabledTransports: ['ws', 'wss'],
				disableStats: true,
				encrypted: isProd ? true : false,
				useTLS: isProd ? true : false,
				forceTLS: isProd ? true : false,
				authEndpoint: authEndpoint,
				auth: {
					headers: {
						'Authorization': `Bearer ${reduxAccount.token}`
					}
				},
			});
		} catch (error) {
			console.log(error)
		}

		socketRef.current.join(`general`)
			.here((users) => {
				console.log(users)

				console.log('connected to general channel')
				usersRef.current = users
				setData({ ...data, 'users': users })
			})
			.joining((user) => socketListener(user, 'joining'))
			.leaving((user) => socketListener(user, 'leaving'))
	}

	function socketListener(user, type) {
		var users = usersRef.current
		if (type === 'joining') {
			usersRef.current = users.push(user)
			setData({ ...data, 'users': users })
		}
		if (type === 'leaving') {
			const index = users.findIndex(item => item.login === user.login);

			if (index !== -1 && index !== undefined) {
				users.splice(index, 1)
			}
			usersRef.current = users
			setData({ ...data, 'users': users })
		}
	}

	useEffect(() => {
		connectSocket()

		return () => {
			if (socketRef.current) {
				socketRef?.current?.leave(`general`)
			}
		}
	}, [])  // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		usersRef.current = data.users
	}, [data])  // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center" onClick={connectSocket}>
					Онлайн пользователи
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '40%' }}>№ {t('pos')}</th>
									<th style={{ 'width': '20%' }}>{t('FIO')}</th>
									<th style={{ 'width': '20%' }}>{t('phone')}</th>
									<th style={{ 'width': '20%' }}>{t('role')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.users?.map((item, index) => (
									<tr key={index}>
										<td>{index + 1} {item?.pos_name}</td>
										<td onClick={() => copyText(item.login)}>
											<CustomTooltip text={item.login}>
												{item.first_name}
											</CustomTooltip>
										</td>
										<td>{item?.phone}</td>
										<td>{item?.role_name}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index